import { Validator, invalid, valid } from "../../../../../../../Shared/validationUtils";

const timeslots = ['morning', 'afternoon', 'evening'] as const
export type Timeslot = typeof timeslots[number];

export type TimeslotSelection = {
  [k in Timeslot]: boolean
}

export const atLeastOneSlotMustBeSelected: (message?: string) => Validator<TimeslotSelection> =
  (message = "Select at least one time slot") => (input: TimeslotSelection) => input.morning || input.afternoon || input.evening ? valid : invalid(message)

export type TimeslotAvailability = TimeslotSelection

export interface LocationOptionPartsOfDayInputProps {
  date: Date
  availability: TimeslotAvailability
  selection: TimeslotSelection
  updateSelection: (selection: TimeslotSelection) => void
}

export const initialTimeslotSelection: TimeslotSelection = {
  morning: false,
  afternoon: false,
  evening: false
}

export const toggleTimeslot = (slot: Timeslot) => (selection: TimeslotSelection) => {
  const updated = {...selection}
  updated[slot] = !selection[slot]
  return updated
}